export const CREATIVE_ADVENTURES = 'creative-adventures';
export const CREATIVE_ADVENTURES_DARK = 'creative-adventures-dark';
export const FIND_YOUR_THING = 'find-your-thing';
export const FIND_YOUR_THING_DARK = 'find-your-thing-dark';
